import { SERVICES } from "../mock";
import { Reveal } from "./Reveal";

export const Services = () => (
  <section id="servizi" data-testid="services-grid-section" className="bg-white py-16 sm:py-24">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal className="max-w-3xl">
        <span className="text-[#c8102e] font-condensed font-bold uppercase tracking-widest text-sm">I servizi</span>
        <h2 className="font-condensed font-extrabold uppercase tracking-tight text-[#191512] text-3xl sm:text-4xl mt-2">
          Di cosa ci occupiamo
        </h2>
        <p className="mt-4 text-slate-600 text-base sm:text-lg">
          Tutti i piccoli interventi che tengono in ordine i tuoi spazi.
        </p>
      </Reveal>
      <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {SERVICES.map((s, i) => (
          <Reveal key={s.label} delay={(i % 4) * 0.08}>
            <div
              data-testid={`service-card-${i}`}
              className="group h-full bg-[#faf7f2] rounded-2xl p-6 border border-slate-100 transition-all duration-300 hover:bg-[#191512] hover:-translate-y-1 hover:shadow-xl cursor-default"
            >
              <span className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-[#c8102e]/10 text-[#c8102e] mb-4 transition-colors duration-300 group-hover:bg-[#1b7a46] group-hover:text-white">
                <s.icon className="w-6 h-6" strokeWidth={2} />
              </span>
              <h3 className="font-condensed font-bold uppercase tracking-tight text-[#191512] text-lg transition-colors duration-300 group-hover:text-white">
                {s.label}
              </h3>
              <p className="mt-1.5 text-slate-500 text-sm transition-colors duration-300 group-hover:text-white/75">
                {s.text}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
